<template>
  <div class="order-status">
    <div v-if="status === 'PAYMENT_SUCCESS'">
      <svg width="120" height="120" fill="none" class="status-icon">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M48.622 9.641a51.628 51.628 0 0132.39 3.2 4.186 4.186 0 103.408-7.647A60 60 0 10120 60.032v-5.135a4.186 4.186 0 10-8.372 0v5.133a51.62 51.62 0 01-10.278 30.882 51.627 51.627 0 11-52.728-81.27zm70.153 8.698a4.186 4.186 0 10-5.923-5.917L59.998 65.33 46.215 51.546a4.186 4.186 0 10-5.92 5.92L57.04 74.21a4.186 4.186 0 005.922-.001l55.814-55.87z" fill="currentColor"/>
      </svg>
      <h2>Bedankt voor het afsluiten van uw abonnement!</h2>
      <p>Bekijk uw mail voor de inloggegevens. Al lid en ingelogd? <br> Bekijk dan <a :href="accountUrl">uw abonnement</a></p>
    </div>
    <div v-else-if="status === 'PAYMENT_PENDING'">
      <svg width="120" height="120" fill="none" class="status-icon">
        <path d="M60 7.5c-2.25 0-3.75 1.5-3.75 3.75V30c0 2.25 1.5 3.75 3.75 3.75s3.75-1.5 3.75-3.75V11.25C63.75 9 62.25 7.5 60 7.5zM28.127 22.875c-1.5-1.5-3.75-1.5-5.25 0s-1.5 3.75 0 5.25L36.002 41.25c.75.75 1.875 1.125 2.625 1.125s1.875-.375 2.625-1.125c1.5-1.5 1.5-3.75 0-5.25L28.127 22.875zM33.75 60c0-2.25-1.5-3.75-3.75-3.75H11.25C9 56.25 7.5 57.75 7.5 60s1.5 3.75 3.75 3.75H30c2.25 0 3.75-1.5 3.75-3.75zM36.002 78.375L22.877 91.5c-1.5 1.5-1.5 3.75 0 5.25.75.75 1.875 1.125 2.625 1.125s1.875-.375 2.625-1.125l13.125-13.125c1.5-1.5 1.5-3.75 0-5.25s-3.75-1.125-5.25 0zM60 86.25c-2.25 0-3.75 1.5-3.75 3.75v18.75c0 2.25 1.5 3.75 3.75 3.75s3.75-1.5 3.75-3.75V90c0-2.25-1.5-3.75-3.75-3.75zM83.998 78.375c-1.5-1.5-3.75-1.5-5.25 0s-1.5 3.75 0 5.25L91.873 96.75c.75.75 1.875 1.125 2.625 1.125s1.875-.375 2.625-1.125c1.5-1.5 1.5-3.75 0-5.25L83.998 78.375zM108.75 56.25H90c-2.25 0-3.75 1.5-3.75 3.75s1.5 3.75 3.75 3.75h18.75c2.25 0 3.75-1.5 3.75-3.75s-1.5-3.75-3.75-3.75zM81.373 42.375c1.125 0 1.875-.375 2.625-1.125l13.125-13.125c1.5-1.5 1.5-3.75 0-5.25s-3.75-1.5-5.25 0L78.748 36c-1.5 1.5-1.5 3.75 0 5.25.375.75 1.5 1.125 2.625 1.125z" fill="currentColor"/>
      </svg>
      <h2>In afwachting van betaling</h2>
      <p>Uw bestelling is in afwachting van uw (handmatige) betaling. Zodra deze is gelukt krijgt u toegang tot uw abonnement.</p>
    </div>
    <div v-else>
      <svg width="120" height="120" fill="none" class="status-icon">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M56.875 90.948a5.625 5.625 0 116.25 9.354 5.625 5.625 0 01-6.25-9.354zm3.843 6.41a1.871 1.871 0 001.157-1.733 1.873 1.873 0 00-2.593-1.732 1.877 1.877 0 00-.608 3.058 1.874 1.874 0 002.044.406zM60 37.5a3.75 3.75 0 013.75 3.75v37.5a3.75 3.75 0 11-7.5 0v-37.5A3.75 3.75 0 0160 37.5z" fill="currentColor"/>
        <path d="M68.105 8.8a9.03 9.03 0 00-16.21 0L4.53 105.29a7.606 7.606 0 006.83 10.96h97.28a7.604 7.604 0 006.83-10.96L68.105 8.8z" stroke="currentColor" stroke-width="7.5" stroke-linecap="round" stroke-linejoin="round" fill="none" />
      </svg>
      <h2>De bestelling is mislukt.</h2>
      <u-button @click="$emit('hide-status')">Probeer het opnieuw</u-button>
    </div>
  </div>
</template>

<script>

  import { mapState } from 'vuex'
  import UButton from './UButton'

  export default {
    components: {
      UButton
    },
    props: {
      status: {
        type: String,
        required: true
      }
    },
    computed: {
      ...mapState({
        accountUrl: state => state.expressCheckoutSettings.accountUrl
      })
    }
  }
</script>

<style lang="scss" scoped>

  @import '../assets/styles/_variables.scss';
  @import '../assets/styles/_mixins.scss';

  .order-status {
    padding: 2.5em 1.5em;
    width: 100%;
    margin: 0 auto;
    text-align: center;

    @include screen(md) {
      padding: 10em 1.5em;
      width: 60%;
    }

    h2 {
      font-size: 1.5em;
      line-height: 1.2;
      margin-bottom: 1em;

      @include screen(md) {
        font-size: 1.75em;
        margin-bottom: 1.5em;
      }

    }

    a {
      color: var(--ec-primary-color, black);
    }

  }

  .status-icon {
    display: inline-block;
    color: var(--ec-primary-color, black);
    margin-bottom: 1.5em;

    @include screen(md) {
      margin-bottom: 3em;
    }

  }


</style>